import type { Hero } from 'types';
import { useMemo } from 'react';
import { Wrap, Button, Heading, RichText } from '@leafwell/components';
import Figure from './figure';
import HeadingBody from './heading-body';

const HeroRichTitle: React.FC<Hero> = ({
  button,
  description,
  image,
  imageAlignment = 'right',
  richTitle,
  subTitle,
  title,
}) => {
  const imageRight = image && imageAlignment === 'right';

  const classNames = useMemo(() => {
    return {
      title: [
        'rich-title max-w-6xl font-semibold',
        imageRight ? 'md:!leading-tight' : 'text-left md:text-center',
      ].join(' '),
      subTitle: 'lg:!-mb-4',
    };
  }, [imageRight]);

  return (
    <Wrap
      tagName="header"
      className={imageRight ? 'md:gap-x-12 md:grid-cols-2 md:items-center' : ''}
    >
      <div
        className={[
          'grid gap-y-6',
          imageRight
            ? 'text-center md:text-left justify-center md:justify-start justify-items-center md:justify-items-start'
            : 'text-center justify-center justify-items-center xl:gap-y-10',
        ].join(' ')}
      >
        {subTitle && (
          <HeadingBody
            level="5"
            title={subTitle}
            className={classNames.subTitle}
          />
        )}
        {title ||
          (richTitle && (
            <HeadingBody
              level="3"
              tagName="h1"
              title={title || richTitle}
              className={classNames.title}
            />
          ))}
        {description &&
          (image ? (
            <RichText
              className="text-2xl md:!text-base max-w-3xl md:max-w-md"
              content={description}
            />
          ) : (
            <Heading
              dangerouslySetInnerHTML={{ __html: description }}
              level="4"
              className="font-sans max-w-3xl !leading-normal"
            />
          ))}
        {button && (
          <Button
            href={button.url}
            label={button.title}
            rounded={true}
            target={button.target}
            variant="secondary"
          />
        )}
      </div>
      {image && <Figure {...image} className="hidden md:block md:self-end" />}
    </Wrap>
  );
};

export default HeroRichTitle;
